<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="商品关键字">
              <a-input
                v-model="queryParam.goods_keywords"
                placeholder="搜索商品关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.goods_id"
                placeholder="选择商品"
                allowClear
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in goodsOptions"
                  :value="option.id"
                >{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="sku关键字">
              <a-input
                v-model="queryParam.attr_keywords"
                placeholder="搜索sku关键字"
              />
            </a-form-item>
          </a-col>

           
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
            
            <a-button
        class="editable-add-btn"
        style="margin-bottom: 10px;"
        @click="handleGoodsSkuDown"
      >
        库存明细下载
      </a-button>
        </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
    <span slot="sku_format" slot-scope="text, record">
        <template>
         <span v-for="(item,i) in record.sku" :key="i">{{item.sku_format}}<br/></span>
        </template>
      </span>
      <span slot="stock" slot-scope="text, record">
        <template>
         <span v-for="(item,i) in record.sku" :key="i">{{item.stock}}<br/></span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">查看</a>
        </template>
      </span>
    </s-table>

    
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import PicUploader from "@/components/PicUploader/"; 
import {
    getGoodsSkuList,goodsSkuDownUrl,
} from "@/api/goods";
import {
    getGoodsOptions,
} from "@/api/order"; 
export default {
  name: "GoodsSkuList",
  components: {
    AInput,
    ATextarea,
    STable,
    PicUploader,
  },
  data() {
    return {
       
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 12,
        },
      },
      form: this.$form.createForm(this),
      mdl: {},
      areas: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { 
      },
      goodsOptions: [],
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "100px",
        },
        {
          title: "名称",
          dataIndex: "title",
          width: "300px",
        },
        {
          title: "规格",
          dataIndex: "sku_format",
          width: "300px",
          scopedSlots: { customRender: "sku_format" },
        }, 
        {
          title: "库存",
          dataIndex: "stock",
          width: "70px",
          scopedSlots: { customRender: "stock" },
        },
        {
          title: "总库存",
          width: "90px",
          dataIndex: "all_stock", 
        },
         
        {
          table: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log("parameter", parameter);
        console.log("queryParam", this.queryParam); 
        this.queryParam = Object.assign(this.queryParam, parameter);
        return getGoodsSkuList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    let that = this;
    that.getGoodsOptions()
  },
  methods: {
    handleGoodsSkuDown() {
      let that = this;
      goodsSkuDownUrl(Object.assign(this.queryParam))
        .then((res) => {
          console.log(res);
          window.open(res.data);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
      
    // 查看sku
    handleEdit(record) {
      const { href } = this.$router.resolve({
        name: "GoodsForm",
        query: { id: record.id, type: 1 },
      }); 
      window.open(href, "_blank");
    },
    getGoodsOptions() {
      let self = this
      getGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },

    
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },
     
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  watch: {
    /*
            'selectedRows': function (selectedRows) {
              this.needTotalList = this.needTotalList.map(item => {
                return {
                  ...item,
                  total: selectedRows.reduce( (sum, val) => {
                    return sum + val[item.dataIndex]
                  }, 0)
                }
              })
            }
            */
  },
};
</script>
